const solarKeywords = [
  'solar', 'panel', 'panels', 'energy', 'renewable', 'photovoltaic', 'pv', 
  'inverter', 'battery', 'storage', 'installation', 'cost', 'price', 
  'warranty', 'maintenance', 'owner', 'contact', 'info', 'product', 
  'specifications', 'efficiency', 'system', 'grid', 'off-grid', 'quote'
];

const bannedWords = [
  'damn', 'fuck', 'shit', 'asshole', 'bitch', 'crap', 
  'piss', 'dick', 'bastard', 'hell', // Add more as needed
];

const isSolarRelated = (input) => {
  const normalizedInput = input.toLowerCase().trim();
  return solarKeywords.some(keyword => normalizedInput.includes(keyword));
};

const containsBannedWords = (input) => {
  const normalizedInput = input.toLowerCase().trim();
  return bannedWords.some(word => normalizedInput.includes(word));
};

export const filterInput = (input) => {
  if (!input.trim()) {
    return { isValid: false, response: "Please enter a valid query." };
  }

  if (containsBannedWords(input)) {
    return { 
      isValid: false, 
      response: "Inappropriate language detected. Please ask a question related to solar products or services."
    };
  }

  if (!isSolarRelated(input)) {
    return { 
      isValid: false, 
      response: "Please ask a question related to solar energy, products, or services."
    };
  }

  return { isValid: true, response: null };
};